export default "__VITE_ASSET__CK2abq$y__"